module.exports = __webpack_public_path__ + "img/img-01.0c570ab6.png";